import { authConfig } from '../auth/authConfig';
import { TokenManager } from './token-manager';

export class SamlAuthService {    
    private tokenManager = TokenManager.getInstance();

    login() {
        window.location.href = authConfig.apiBaseUrl + authConfig.saml.loginUrl;
    }

    async handleCallback(): Promise<boolean> {
        const urlParams = new URLSearchParams(window.location.search);
        const sessionId = urlParams.get('session');

        if (!sessionId) {
            console.error('No session ID in URL');
            return false;
        }

        try {
            const response = await fetch(`${authConfig.apiBaseUrl}${authConfig.saml.token}/${sessionId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            });
            if (response.ok) {
                const tokens = await response.json();
                this.tokenManager.setToken(tokens.accessToken);
                return true;
            }

            console.error('Token exchange failed');
            return false;
        } catch (error) {
            console.error('Failed to retrieve token: ', error);
            return false;
        }
    }

    async logout(): Promise<void> {
        try {
            await fetch(`${authConfig.apiBaseUrl}{authConfig.saml.logoutUrl}`, {
                method: 'POST',
                credentials: 'include'
            });
        } catch (error) {
            console.error('Logout API call failed: ', error);
        } finally {
            // Always clear local storage even if API fails
            this.tokenManager.clearToken();
        }
    }

    isAuthenticated(): boolean {
        try {
            const token = JSON.parse(this.tokenManager.getToken());
            if (!token.accessToken) return false;

            // Check if token is expired
            const payload = JSON.parse(atob(token.accessToken.split('.')[1]));
            const expiresAt = payload.exp * 1000;
            return Date.now() < expiresAt;
        } catch {
            return false;
        }
    }
}